import { CandlestickData } from "lightweight-charts"

export class SpecialChart<T extends CandlestickData = CandlestickData> {
    candles: T[]

    constructor(candles: T[]) {
        this.candles = candles
    }

    getCandles(): CandlestickData[] {
        return []
    }
}